import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import Mission from '../components/Mission';
import FAQ from '../components/FAQ';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import InterestModal from '../components/InterestModal';

const HomePage = () => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Scroll to section when coming from another page 
  useEffect(() => {
    const scrollToTarget = location.state?.scrollTo;
    if (scrollToTarget) {
      // Allow time for the DOM to render
      setTimeout(() => {
        const element = document.getElementById(scrollToTarget);
        if (element) {
          const offsetTop = element.offsetTop - 120;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
        // Clear the state to prevent re‑scrolling on later re‑renders
        window.history.replaceState({}, document.title);
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header onShowInterest={handleShowModal} />
      <Hero onShowInterest={handleShowModal} />
      <Features />
      <HowItWorks />
      <Testimonials onShowInterest={handleShowModal} />
      <Mission />
      <FAQ />
      <Newsletter />
      <Footer />
      <InterestModal show={showModal} handleClose={handleCloseModal} />
    </>
  );
};

export default HomePage;